import axios from 'axios';
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import OPDInformation from '../../components/patient-timeline/opd';
import { successToast, errorToast } from "../../components/toastmessage/toastmessage";

const OPDContainer = () => {

    const submitOpdInfo = (event, patientId, body) => {
        event.preventDefault();
         axios.post(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/${patientId}/OPD`, body).then((res) => {
            if (res?.status === 200) {
                successToast(res?.data?.message);
            }
        }).catch((err) => {
            errorToast(err?.response?.data?.error || err?.response?.data?.message)
        })
    }

    return (
        <div className="list">
            <Sidebar />
            <div className="listContainer">
                <Navbar />
                <OPDInformation submitOpdInfo={submitOpdInfo} />
            </div>
        </div>
    )
}

export default OPDContainer;
